// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-bg {
  margin-top: 300px;
  height: 100vh;
  width: 100%;
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.landing-body-wrapper {
  position: relative;
  width: 100%;
  height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.landing-body-wrapper h1 {
  display: flex;
  justify-content: right;
  margin: 8rem auto 0 auto;
}
.landing-buttons-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.main-title {
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 1px;
}
.main-subtitle {
  display: flex;
  margin-bottom: 2rem;
}
.main-subtitle:hover {
  background-color: rgb(1, 1, 1, 0.8);
  color: var(--secondaryColor);
  padding-left: 3rem;
  padding-right: 3rem;
  transition: all 0.5s ease-out;
}

.main-titles-align {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}

.social-media-section {
  position: absolute;
  bottom: 5%;
  width: 40%;
  margin-left: 4rem;
}
.bottom-line {
  margin-block-start: -3rem;
}

@media only screen and (max-width: 321px) {
  .landing-buttons-wrapper {
    margin-top: 0 !important;
  }
}

@media only screen and (max-width: 415px) {
  .landing-bg {
    margin-top: 150px;
  }
}

@media only screen and (max-width: 677px) {
  .main-title {
    font-size: 2rem;
  }
  .main-subtitle {
    text-align: center;
  }

  .main-titles-align {
    align-items: center;
    padding-right: 0;
    padding-left: 0;
  }

  .landing-body-wrapper {
    width: 100%;
  }

  .landing-body-wrapper h1 {
    margin: 6rem auto 2rem auto;
    text-align: center;
  }

  .landing-buttons-wrapper {
    flex-direction: column;
    margin-top: 6rem;
  }

  .bottom-line {
    width: 60%;
    margin-block-start: -3rem;
  }

  .social-media-section {
    width: 60%;
    margin-left: 2rem;
  }
}

@media only screen and (max-width: 992px) {
  .main-titles-align {
    align-items: center;
    padding-right: 0;
    padding-left: 0;
  }
  .main-title {
    font-size: 2rem;
  }
  .bottom-line {
    margin-block-start: -3rem;
  }
}

.skills-block {
  position: absolute;
  bottom: 3%;
  right: 5%;
}
.skills-block:hover {
  background-color: rgb(1, 1, 1, 0.8);
  color: var(--secondaryColor);
  padding-left: 3rem;
  padding-right: 3rem;
  transition: all 0.5s ease-out;
}
`, "",{"version":3,"sources":["webpack://./src/css/landing.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B","sourcesContent":[".landing-bg {\n  margin-top: 300px;\n  height: 100vh;\n  width: 100%;\n}\n\n@keyframes gradient {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.landing-body-wrapper {\n  position: relative;\n  width: 100%;\n  height: 90%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.landing-body-wrapper h1 {\n  display: flex;\n  justify-content: right;\n  margin: 8rem auto 0 auto;\n}\n.landing-buttons-wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n.main-title {\n  text-transform: uppercase;\n  font-weight: 700;\n  letter-spacing: 1px;\n}\n.main-subtitle {\n  display: flex;\n  margin-bottom: 2rem;\n}\n.main-subtitle:hover {\n  background-color: rgb(1, 1, 1, 0.8);\n  color: var(--secondaryColor);\n  padding-left: 3rem;\n  padding-right: 3rem;\n  transition: all 0.5s ease-out;\n}\n\n.main-titles-align {\n  display: flex;\n  align-items: flex-end;\n  flex-direction: column;\n}\n\n.social-media-section {\n  position: absolute;\n  bottom: 5%;\n  width: 40%;\n  margin-left: 4rem;\n}\n.bottom-line {\n  margin-block-start: -3rem;\n}\n\n@media only screen and (max-width: 321px) {\n  .landing-buttons-wrapper {\n    margin-top: 0 !important;\n  }\n}\n\n@media only screen and (max-width: 415px) {\n  .landing-bg {\n    margin-top: 150px;\n  }\n}\n\n@media only screen and (max-width: 677px) {\n  .main-title {\n    font-size: 2rem;\n  }\n  .main-subtitle {\n    text-align: center;\n  }\n\n  .main-titles-align {\n    align-items: center;\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .landing-body-wrapper {\n    width: 100%;\n  }\n\n  .landing-body-wrapper h1 {\n    margin: 6rem auto 2rem auto;\n    text-align: center;\n  }\n\n  .landing-buttons-wrapper {\n    flex-direction: column;\n    margin-top: 6rem;\n  }\n\n  .bottom-line {\n    width: 60%;\n    margin-block-start: -3rem;\n  }\n\n  .social-media-section {\n    width: 60%;\n    margin-left: 2rem;\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .main-titles-align {\n    align-items: center;\n    padding-right: 0;\n    padding-left: 0;\n  }\n  .main-title {\n    font-size: 2rem;\n  }\n  .bottom-line {\n    margin-block-start: -3rem;\n  }\n}\n\n.skills-block {\n  position: absolute;\n  bottom: 3%;\n  right: 5%;\n}\n.skills-block:hover {\n  background-color: rgb(1, 1, 1, 0.8);\n  color: var(--secondaryColor);\n  padding-left: 3rem;\n  padding-right: 3rem;\n  transition: all 0.5s ease-out;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
